<template>
    <div class="screen">
        <div id="title-section">
            <div class="title">{{ title }}</div>
            <div v-if="false" class="sub-title">{{ subTitle }}</div>
        </div>

        <!-- Leaderboard list -->
        <div class="list" v-if="usersData && usersData.length">
            <div v-for="(row, idx) in usersData" :key="idx" class="card" :class="{
                'is-top': idx === 0,
                'accent-gold': idx === 0,
                'accent-silver': idx === 1,
                'accent-bronze': idx === 2,
                'accent-teal': idx >= 3 && idx <= 3,
                'accent-none': idx >= 4
            }">
                <!-- left accent -->
                <div class="accent"></div>

                <!-- content -->
                <div class="card-inner" with="100%">
                    <div class="rank-col" style="min-width: 10%; max-width: 10%;">
                        <div class="rank">
                            <!-- <span class="rank-box"></span> -->
                            <span class="rank-num">{{ rankByIndex ? pad2(idx + 1) : pad2(row.curr_rank) }}</span>
                        </div>

                        <div class="delta"
                            :class="deltaClass(row.curr_rank > row.prev_rank ? 'up' : (row.curr_rank < row.prev_rank ? 'down' : 'new'))">
                            <template v-if="row.curr_rank > row.prev_rank">
                                <span class="tri up"></span>
                                <span class="delta-val">{{ row.curr_rank - row.prev_rank }}</span>
                            </template>
                            <template v-else-if="row.curr_rank < row.prev_rank">
                                <span class="tri down"></span>
                                <span class="delta-val">{{ row.prev_rank - row.curr_rank }}</span>
                            </template>
                            <template v-else>
                                <span class="new">New!</span>
                            </template>
                        </div>
                    </div>

                    <div class="avatar-col" style="min-width: 10%; max-width: 10%;">
                         <IconUser size="2.3rem"/>
                    </div>

                    <div v-if="row.user" class="name-col"
                        style="min-width: 65%; max-width: 60%;">
                        <div :title="row.user.name" class="name">{{ row.user.name }}</div>
                        <div :title="row.user.platoon_name" class="team">{{ row.user.platoon_name }}</div>
                    </div>

                    <div class="score-col" 
                    style="min-width: 10%; max-width: 10%;padding-right: 0.5rem;">
                        <div v-if="boardType == 'steps'" class="score">{{ formatScore(row.steps) }}</div>
                        <div v-else-if="boardType == 'calories'" class="score">{{ formatScore(row.calories) }}</div>
                        <div v-else class="score">{{ formatScore(row.score) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconUser from "@/shared/Controls/Icons/IconUser.vue";

export default {
    name: "LeaderboardList",
    components: {
        IconUser,
    },
    props: {
        title: { type: String, default: "" },
        subTitle: { type: String, default: "" },
        dateLabel: { type: String, default: "03 Feb 2026" },
        usersData: { type: Array, default: () => [] },
        boardType: { type: String, default: "strain" },
        rankByIndex: { type: Boolean, default: false },
    },
    data() {
        return {
            topTabs: ["STRAIN", "RECOVERY", "SLEEP"],
            activeTopTab: "STRAIN",
            rangeTabs: ["Day", "Week", "Month"],
            activeRange: "Day",
            //rows: this.userData
        };
    },
    computed: {
    },
    methods: {
        pad2(n) {
            return String(n).padStart(2, "0");
        },
        formatScore(n) {
            if (n == null) return "0";
            const s = Number(n);
            return s.toLocaleString(undefined, { maximumFractionDigits: 4 });
        },
        deltaClass(type) {
            return {
                "delta-up": type === "up",
                "delta-down": type === "down",
                "delta-new": type === "new"
            };
        }
    }
};
</script>

<style scoped>
/* ===== Screen base ===== */
.screen {
    min-height: 100vh;
    padding-left: 1rem;
    background: radial-gradient(1200px 900px at 20% -10%, rgba(255, 255, 255, 0.06), rgba(0, 0, 0, 0) 55%),
        radial-gradient(900px 900px at 110% 10%, rgba(255, 255, 255, 0.04), rgba(0, 0, 0, 0) 55%),
        #070808;
    color: #e9ecef;
    /* font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; */
    font-family: "NotoSans-Regular", "Open Sans", sans-serif;
}

.title {
    text-align: center;
    font-size: 1.3rem;
    font-weight: bold;
    font-family: emoji;
    padding-top: 0.5rem;
    /* padding-bottom: 1rem; */
    font-family: "NotoSans-Regular", "Open Sans", sans-serif;
}

.sub-title {
    text-align: center;
    font-size: 0.9rem;
    font-weight: 800;
    font-family: emoji;
}

/* ===== Top tabs ===== */
.top-tabs {
    position: relative;
    display: flex;
    gap: 1rem;
    padding: 6px 2px 16px;
    align-items: center;
}

.top-tab {
    position: relative;
    border: 0;
    background: transparent;
    color: rgba(233, 236, 239, 0.75);
    font-weight: 700;
    letter-spacing: 1.5px;
    font-size: 1rem;
    padding: 10px 0;
    cursor: pointer;
}

.top-tab.active {
    color: #ffffff;
}

.top-underline {
    position: absolute;
    left: 2px;
    bottom: 4px;
    height: 8px;
    border-radius: 999px;
    background: #ffffff;
    opacity: 0.95;
    transition: transform 220ms ease;
}

/* ===== Header row ===== */
.header-row {
    margin-top: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.date-wrap {
    display: flex;
    align-items: center;
    gap: 14px;
}

.date {
    font-size: 2.25rem;
    letter-spacing: 1px;
    color: #f2f4f6;
    font-weight: 800;
}

.info-btn {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 999px;
    border: 2px solid rgba(255, 255, 255, 0.18);
    background: rgba(255, 255, 255, 0.02);
    color: rgba(255, 255, 255, 0.55);
    font-weight: 900;
    cursor: pointer;
}

/* ===== Range tabs ===== */
.range-tabs {
    display: inline-flex;
    gap: 10px;
}

.range-tab {
    border: 0;
    cursor: pointer;
    padding: 10px 16px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.06);
    color: rgba(233, 236, 239, 0.45);
    font-weight: 700;
    font-size: 16px;
}

.range-tab.active {
    background: rgba(255, 255, 255, 0.22);
    color: rgba(255, 255, 255, 0.9);
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
}

/* ===== List ===== */
.list {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

/* ===== Card ===== */
.card {
    position: relative;
    border-radius: 1rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.035));
    box-shadow: 0 0.7rem 1.7rem rgba(0, 0, 0, 0.45);
    overflow: hidden;
}

.card-inner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.5rem;
}

/* left accent stripe */
.accent {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0.5rem;
    background: rgba(255, 255, 255, 0.12);
}

/* Accents per rank (approx like screenshot) */
.accent-gold .accent {
    background: linear-gradient(180deg, rgba(235, 197, 112, 0.95), rgba(235, 197, 112, 0.30));
}

.accent-silver .accent {
    background: linear-gradient(180deg, rgba(220, 220, 220, 0.70), rgba(220, 220, 220, 0.18));
}

.accent-bronze .accent {
    background: linear-gradient(180deg, rgba(195, 120, 98, 0.75), rgba(195, 120, 98, 0.18));
}

.accent-teal .accent {
    background: linear-gradient(180deg, rgba(120, 200, 190, 0.45), rgba(120, 200, 190, 0.14));
}

.accent-none .accent {
    background: rgba(255, 255, 255, 0.10);
}

/* ===== Rank + delta ===== */
.rank-col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    /* gap: 0.5rem; */
    padding-left: 0.5rem;
}

.rank {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.rank-box {
    width: 1rem;
    height: 1rem;
    border: 3px solid rgba(255, 255, 255, 0.85);
    border-radius: 4px;
    transform: skewX(-10deg);
    opacity: 0.85;
}

.rank-num {
    font-size: 1rem;
    font-weight: 900;
    letter-spacing: 1px;
    color: rgba(255, 255, 255, 0.92);
}

.delta {
    display: flex;
    align-items: center;
    gap: 0.1rem;
    font-weight: 800;
    letter-spacing: 0.6px;
    font-size: 0.8rem;
    opacity: 0.95;
}

.tri {
    width: 0;
    height: 0;
    border-left: 0.4375rem solid transparent;
    border-right: 0.4375rem solid transparent;
}

.tri.up {
    border-bottom: 0.7rem solid rgba(70, 205, 170, 0.95);
}

.tri.down {
    border-top: 0.7rem solid rgba(240, 80, 80, 0.95);
}

.delta-up {
    color: rgba(70, 205, 170, 0.95);
}

.delta-down {
    color: rgba(240, 80, 80, 0.95);
}

.delta-new .new {
    color: rgba(70, 205, 170, 0.95);
}

/* ===== Name + team ===== */
.name-col {
    min-width: 0;
    padding-left: 0.5rem;
}

.name {
    font-size: 1rem;
    font-weight: 900;
    color: rgba(255, 255, 255, 0.92);
    line-height: 1.1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.team {
    margin-top: 6px;
    font-size: 1rem;
    font-weight: 700;
    color: rgba(190, 198, 203, 0.72);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ===== Score ===== */
.score-col {
    display: flex;
    justify-content: flex-end;
}

.score {
    font-size: 1rem;
    font-weight: 900;
    color: rgba(75, 210, 185, 0.80);
    letter-spacing: 1px;
}

/* ===== Responsive tweaks ===== */
@media (max-width: 520px) {
    .date {
        font-size: 30px;
    }

    .card-inner {
        grid-template-columns: 82px 72px 1fr 86px;
        padding: 1rem;
    }

    .name {
        font-size: 1.375rem;
    }

    .team {
        font-size: 1rem;
    }

    .score {
        font-size: 1.5rem;
    }

    .top-tab {
        font-size: 1rem;
    }
}
</style>
